/* step one of mobile verification, entering a number */
<template>
  <div>
    <VerifyPhoneNumberForm
      @form-successfully-submitted="handleSuccessfulSubmission"
      @form-unsuccessfully-submitted="handleFailedSubmission"
    />
  </div>
</template>
<script>
import log from '@/services/log';
import VerifyPhoneNumberForm from '@/components/shared/VerifyPhoneNumberForm.vue';

export default {
  name: 'Mobile',
  components: {
    VerifyPhoneNumberForm,
  },
  mounted() {
    this.$store.commit('SET_LOADING', false);
  },
  methods: {
    handleSuccessfulSubmission() {
      this.$router.push({ path: `${this.getProductBasePath()}/insurance-application/verification-code` });
    },
    handleFailedSubmission() {
      log('Error in sending verification code! [insurance]');
      this.$router.push({ name: `insurance-error-${this.baseRoute}` });
    },
  },
};
</script>
